<template>
  <el-container>
    <el-header class="header">
      <el-row class="headRow">
        <el-col class="headCol" :span="24">
          <img src="/static/logo2.png" />
        </el-col>
      </el-row>
    </el-header>
    <el-main id="app">
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
html {
  background: #fff;
  // background: whitesmoke;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.header {
  height: 100px;
  .headRow {
    height: 100%;
    .headCol {
      height: 100%;
      img {
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue